import React from 'react';
import {
  Switch, Route, Redirect, Link,
} from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';

import { Intl } from 'components';
import { outAdministrationRoutes } from 'config/Routes';

const Administration = ( { currentPath, pathLayout } ) => {
  const getRoutes = ( routesList ) => _.map( routesList, ( route ) => (
    <Route
      exact={route.exact}
      path={route.layout + route.path}
      render={( props ) => ( <route.component {...props} /> )}
      key={route.layout + route.path}
    />
  ) );

  return (
    <>
      <Container fluid>
        <Row className="mb-3 py-2 border-bottom border-gray-3">
          <Col md={6} className="m-auto d-md-flex justify-content-between">
            {_.map( outAdministrationRoutes, ( route ) => (
              <Link
                key={route.path}
                to={route.layout + route.path}
                className="d-flex flex-column align-items-center mt-3 mt-md-0"
              >
                <i className={classnames( route.icon, 'fa-3x text-gray-7' )} />
                <p className={classnames( 'm-0', {
                  'text-gray-7': route.layout + route.path !== currentPath,
                  'text-mp-orange-1': route.layout + route.path === currentPath,
                } )}
                >
                  <Intl id={route.name} />
                </p>
              </Link>
            ) )}
          </Col>
        </Row>

        <Switch>
          {getRoutes( outAdministrationRoutes )}
          <Redirect from="*" to={`${pathLayout}/hired-numbers`} />
        </Switch>
        {/* <Col className="text-sm" style={{"paddingLeft": "30px"}}>
        <Intl id="footNodeOnAdministration" />
        </Col> */}
      </Container>
    </>
  );
};


export default Administration;
